/** @hidden */
var DrawWrapper =
/** @class */
function () {
  function DrawWrapper(engine, createMaterialContext) {
    if (createMaterialContext === void 0) {
      createMaterialContext = true;
    }

    this.effect = null;
    this.defines = null;
    this.drawContext = engine.createDrawContext();

    if (createMaterialContext) {
      this.materialContext = engine.createMaterialContext();
    }
  }

  DrawWrapper.IsWrapper = function (effect) {
    return effect.getPipelineContext === undefined;
  };

  DrawWrapper.GetEffect = function (effect) {
    return effect.getPipelineContext === undefined ? effect.effect : effect;
  };

  DrawWrapper.prototype.setEffect = function (effect, defines) {
    this.effect = effect;

    if (defines !== undefined) {
      this.defines = defines;
    }
  };

  return DrawWrapper;
}();

export { DrawWrapper };